var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from "react";
import Translate from "react-translate-component";

var Incognito = function (_React$Component) {
    _inherits(Incognito, _React$Component);

    function Incognito() {
        _classCallCheck(this, Incognito);

        return _possibleConstructorReturn(this, (Incognito.__proto__ || Object.getPrototypeOf(Incognito)).apply(this, arguments));
    }

    _createClass(Incognito, [{
        key: "render",
        value: function render() {
            var props = this.props;

            return React.createElement(
                "div",
                { id: "incognito" },
                React.createElement(
                    "div",
                    { className: "dismiss", onClick: props.onClickIgnore },
                    "\xD7"
                ),
                React.createElement(
                    "strong",
                    null,
                    React.createElement(Translate, { content: "incognito.mode" }),
                    " "
                ),
                React.createElement(Translate, { content: "incognito.warning" })
            );
        }
    }]);

    return Incognito;
}(React.Component);

export default Incognito;